module.exports = __webpack_public_path__ + "img/trf.86deed88.png";